import React from "react";
import { CV } from "../components/cv";
import NellLImg from "@/assets/images/nell-l.png";

export default function CVNellLevasseur() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Nell Levasseur";
  }, []);

  return (
    <CV
      name="Nell Levasseur"
      title="Data & BI Specialist"
      subtitle="5+ years of experience in Power BI, SQL, Python and R — KPI tracking, forecasting and scenario modeling, currently based in Malmö"
      photo={NellLImg}
      summary="Data Analyst with 5+ years' experience in Power BI, SQL, Python, and R. Skilled in KPI tracking, forecasting, and scenario modeling to support planning and decision-making. Strong communicator with international experience, eager to apply analytics expertise to financial controlling, business data analysis, and strategic reporting."
      skills={{
        Visualization: ["Power BI (DAX, Power Query)", "Tableau", "Looker Studio"],
        "Analytics & Modeling": [
          "Predictive Modeling",
          "Regression",
          "PCA",
          "NLP",
          "Forecasting",
        ],
        "Data Practices": [
          "Data Pipelines",
          "Automation",
          "Variance Analysis",
          "Compliance Reporting",
        ],
        Languages: ["Python", "R", "SAS (Certified Specialist: Base Programming)", "SQL"],
        Tools: ["Excel", "Word", "PowerPoint"],
        Spoken: ["French (native)", "English (TOEIC 950/990)", "Swedish (intermediate)"],
      }}
      experience={[
        {
          role: "Data & BI Specialist",
          company: "Scandinavian Cosmetics, Malmö",
          period: "Jan 2026 – May 2026",
          description:
            "Improved quality and consistency of centralized sales datasets used for operational and business reporting. Delivered trusted reporting insights to stakeholders and improved access to reliable data. Standardized reporting inputs across regional teams.",
          highlights: [
            "Worked in Microsoft Fabric lakehouse environment supporting scalable reporting.",
          ],
        },
        {
          role: "HR Data Analyst",
          company: "Air Liquide, Malmö, Sweden",
          period: "Jan 2024 – Jan 2026",
          description:
            "Built Power BI dashboards to monitor KPIs, budgets, and workforce metrics. Developed SQL pipelines to automate reporting and ensure accuracy. Applied regression, PCA, and NLP to identify trends and forecast outcomes. Delivered insights for salary reviews, workforce allocation, and compliance.",
          highlights: [
            "Tools: Power BI (DAX, Power Query), SQL, Python, Excel, Looker Studio",
          ],
        },
        {
          role: "HR Data Analyst (Junior)",
          company: "Société Générale, Paris La Défense",
          period: "Sep 2022 – Dec 2023",
          description:
            "Designed KPI dashboards in Power BI and Tableau for performance and training analytics. Automated recurring reporting with SQL and SAS. Produced compliance reports and insights for international teams.",
          highlights: ["Tools: Power BI, Tableau, SAS, Excel"],
        },
        {
          role: "HR Analyst (Internship)",
          company: "Société Générale, Paris La Défense",
          period: "Sep 2021 – Sep 2022",
          description:
            "Conducted diversity and mobility analysis using statistical models. Built dashboards and reports for organizational planning and compliance. Ensured data quality and reporting integrity.",
          highlights: ["Tools: SAS, R, Tableau, Excel"],
        },
      ]}
      education={[
        {
          degree: "Master's degree – Data Analyst",
          institution:
            "IAE Gustave Eiffel, Champs-sur-Marne (Predictive Modeling, Econometrics, Machine Learning)",
          year: "2020 – 2022",
        },
        {
          degree: "Bachelor's Degree (Study Abroad)",
          institution: "University of Vienna, Austria",
          year: "2019 – 2020",
        },
      ]}
      otherActivities={{
        title: "Volunteering & Interests",
        description:
          "Volunteer with CGCV in Togo — school-building and tutoring (2017). Interests include travel (Austria, Denmark, Sweden, Poland, Slovakia, Togo), swimming at club-level competition, and hiking.",
      }}
    />
  );
}
